export default __webpack_public_path__ + "static/media/copy1.21fb5fd4.svg";